export const CALLBACK_URL = new URL(`${window.location.origin}/callback`);
